import { Component, OnInit, OnDestroy, AfterViewInit, ChangeDetectorRef, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Company, ContentProvider, KnowledgeSkill, Pagination } from '@lighty';
import { EmitterService, LoaderService, ParamsService, StorageService, TranslateService } from '@services';
import { SubscriptionCollection } from '@classes';
import { DataHelper } from '@helpers';
import * as moment from 'moment';
import { forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { gsap } from 'gsap';

@Component({
    selector: 'msc-learn-catalogue-watch',
    templateUrl: './watch.component.html',
    styleUrls: ['./watch.component.scss']
})
export class LearnCatalogueWatchComponent implements OnInit, OnDestroy {
    private subscriptionCollection: SubscriptionCollection = new SubscriptionCollection();
    private me: any;
    private availableSkills: KnowledgeSkill[];
    public company: Company;
    public background: string = 'https://static.myskillcamp.com/lxp/images/hero-catalog.png';
    public contents: any = [
        { isSkeleton: true },
        { isSkeleton: true },
        { isSkeleton: true },
        { isSkeleton: true },
        { isSkeleton: true },
        { isSkeleton: true },
        { isSkeleton: true },
        { isSkeleton: true },
        { isSkeleton: true },
        { isSkeleton: true },
        { isSkeleton: true },
        { isSkeleton: true },
        { isSkeleton: true },
        { isSkeleton: true },
        { isSkeleton: true }
    ];
    public pagination: Pagination;
    public events: any;
    public explore: any;
    public thematic: any;
    public level: any;
    public mode: string = 'list';
    public query: string;
    public activeFilters: boolean = false;
    public filters: any = {};
    public params: any;
    public searching: boolean = false;
    // [SCROLL-TO-TOP] Controla la visibilidad del botón de volver arriba
    public showScrollTop: boolean = false;
    public isSearching: boolean = false;
    public loading: boolean = false;
    public loadingFilter: boolean = false;
    public isLoading: boolean = false;
    public clientPage: number = 1;
    public readonly ITEMS_PER_PAGE = 20;
    public sidebarCollapsed: boolean = false;
    //catalogue new
    public catalogue: any[] = [];
    private originalCatalogue: any[] = [];
    private originalContents: any[] = [];
    private cachedSubscribedIds: Set<any> = new Set();
    private searchSubscription: any;
    // Propiedades filtros
    public availableTypes: any[] = [];
    public availableLanguages: any[] = [];
    public availableProviders: any[];
    public filtersModal: any;
    public isLoadingFilters: boolean = true;
    /* ===== RESPALDO CARRUSEL: CONTROLES DESLIZABLES =====
    public canScrollLeft: boolean = false;
    public canScrollRight: boolean = false;
    */
    // Variables para rastrear cambios de filtros (mutua exclusividad)
    private lastSelectedTypesCount: number = 0;
    private lastSelectedProvidersCount: number = 0;
    private lastFilterState: any = null;
    // Grupo 1: Tipos de contenido (curso, ruta, contenido externo)
    public groupedTypes: any[] = [];
    // Grupo 2: Proveedores (Netzun, Griky, etc.)
    public groupedProviders: any[] = [];

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private storageService: StorageService,
        private emitterService: EmitterService,
        private contentProvider: ContentProvider,
        private loaderService: LoaderService,
        private paramsService: ParamsService,
        private translateService: TranslateService,
        private changeDetectorRef: ChangeDetectorRef
    ) { }

    ngOnInit(): void {
        this.me = this.storageService.get('me');
        this.company = this.storageService.get('company');
        this.background = this.company.experience && this.company.experience.cataloguePicture
            ? this.company.experience.cataloguePicture + '?size=raw'
            : this.background;

        //this.initData();
        this.route.params.subscribe((params) => {
            this.params = params;
        });

        this.getEvents();

        //catalogue all
        this.getCatalogue();
        this.subscribeToSearch(); // activa búsquedas
        
        // Escuchar evento de reset de filtros desde topbar-filters
        this.subscriptionCollection.subscribe = this.emitterService.get('filter.reset.carousel').subscribe(() => {
            this.onFilterReset();
        });
        
        this.getMeta(); // Cargar filtros
    }

    /**
     * Enriquece items del catálogo con información de suscripción
     */
    private enrichCatalogueWithSubscriptionData(items: any[], subscribedIds: Set<any>): any[] {
        console.log('[WATCH] enrichCatalogueWithSubscriptionData - items type:', typeof items, 'is array:', Array.isArray(items), 'items:', items);
        console.log('[WATCH] enrichCatalogueWithSubscriptionData - subscribedIds:', subscribedIds);
        
        if (!Array.isArray(items)) {
            console.warn('[WATCH] enrichCatalogueWithSubscriptionData - items is NOT an array, returning empty array');
            return [];
        }
        
        return items.map((item: any) => {
            const itemId = item.data?.id || item.id;
            return {
                ...item,
                data: {
                    ...item.data,
                    subscribed: subscribedIds.has(itemId) || item.data?.subscribed || false
                }
            };
        });
    }

    ngDoCheck(): void {
        // Detectar cambios en los filtros y sincronizar con la sección de carrusel
        if (this.filters && (this.filters.contentTypes || this.filters.providers)) {
            const currentFilterState = {
                contentTypes: JSON.stringify(this.filters.contentTypes),
                providers: JSON.stringify(this.filters.providers)
            };

            if (this.lastFilterState === null || 
                this.lastFilterState.contentTypes !== currentFilterState.contentTypes ||
                this.lastFilterState.providers !== currentFilterState.providers) {
                this.lastFilterState = currentFilterState;
                this.syncFiltersFromTopbar();
            }
        }
    }

    ngOnDestroy(): void {
        this.subscriptionCollection.unsubscribe();
    }

    // [SCROLL-TO-TOP] Escucha el scroll de la ventana; muestra el botón al superar 300px de desplazamiento
    @HostListener('window:scroll', [])
    onWindowScroll(): void {
        this.showScrollTop = window.scrollY > 300;
    }

    // [SCROLL-TO-TOP] Desplaza la página suavemente hasta el tope
    scrollToTop(): void {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    // [SCROLL-TO-TOP] Devuelve true si el floating-chat IA está habilitado en la empresa,
    // para posicionar el botón por encima del ícono del chat y no sobreponerlo
    get isChatEnabled(): boolean {
        return this.company?.permissions?.companyAiAssistant === true;
    }

    private initData(): void {
        if (this.route.snapshot.data.explore) {
            this.explore = this.route.snapshot.data.explore.catalogue;
            this.pagination = this.route.snapshot.data.explore.pagination;
        } else if (this.route.snapshot.data.thematic) {
            this.thematic = this.route.snapshot.data.thematic;
            this.pagination = this.route.snapshot.data.thematic.pagination;
        } else {
            this.level = this.route.snapshot.data.level;
            this.pagination = this.route.snapshot.data.level.pagination;
        }
    }

    private subscribeToSearch(): void {
        this.subscriptionCollection.subscribe = this.emitterService.get('search.catalogue').subscribe((query) => {
            if (typeof query === 'string') {
                setTimeout(() => this.isSearching = true, 200);
                this.search(query);
                this.emitterService.set('search.catalogue', {});
            }
        });
    }

    private getEvents(): void {
        const params = {
            include: 'attendees',
            user_course: 0
        };

        this.contentProvider.getEvents(this.company.id, params).subscribe((data) => {
            this.events = this.groupEvents(data.closest, data.events);
        });
    }

    private groupEvents(closest: any, events: any): any {
        for (const item of closest) {
            item.eventDate = moment(item.start).format('YYYY-MM-DD');
        }
        const groupedData = DataHelper.groupBy(closest, 'eventDate', { key: 'date', value: 'events' });
        const mergedData = DataHelper.mergeGroupedCollection(groupedData, events, { key: 'date', value: 'events' });

        for (const event of mergedData) {
            event.items = event.events;
            delete event.events;
        }

        return mergedData;
    }
    //catalogue new
    /*search(query?: string): void {
        this.searching = true;
        this.loaderService.run();

        // Espera 50ms para asegurarte de que [(filters)] esté actualizado
        setTimeout(() => {
            const params = this.paramsService.getCatalogue(
                this.filters,
                this.company.id,
                query || this.query,
                null,
                { browse: this.params?.type },
                this.me
            );

            if (query || this.query || this.activeFilters) {
                this.contentProvider.getCatalogue(params).subscribe((data) => {
                    this.contents = data.catalogue;
                    this.pagination = data.pagination;
                    this.isSearching = true;
                    this.searching = false;
                });
            } else {
                this.getCatalogue();
            }
        }, 50); // o 0 también puede funcionar
    }*/

    search(query?: string): void {
        this.searching = true;
        this.loaderService.run();
        this.activeRanking = '';
        this.clientPage = 1;

        console.log('[WATCH] search() called with:', { query, query_state: this.query, activeFilters: this.activeFilters, filters: this.filters });
        
        if (!(query || this.query || this.activeFilters)) {
            console.log('[WATCH] No query, query_state, or activeFilters - calling getCatalogue()');
            this.query = null;
            this.filters = {};
            this.activeFilters = false;
            this.pagination = null;

            this.getCatalogue();
            this.searching = false;
            this.loaderService.stop();
            return;
        }

        console.log('[WATCH] Applying filters - making API call');
        // When a text query is present, don't pass 'browse' so the API searches across
        // all content types — matching the same behaviour as the header predictive search.
        // 'browse' is only meaningful for category-browsing (no query), not for text search.
        const hasTextQuery = !!(query || this.query);
        const browseOptions = hasTextQuery ? null : { browse: this.params?.type };
        const params = this.paramsService.getCatalogue(
            this.filters,
            this.company.id,
            query || this.query,
            null,
            browseOptions,
            this.me
        );

        if (this.searchSubscription) { this.searchSubscription.unsubscribe(); }
        this.searchSubscription = forkJoin({
            catalogue: this.contentProvider.getCatalogue(params).pipe(
                catchError(() => of({ catalogue: [], pagination: null }))
            ),
            contents: this.contentProvider.getContents(params).pipe(
                catchError(() => of({ contents: [] }))
            )
        }).subscribe({
            next: (data: any) => {
                // Poblar caché de suscripciones a partir de getContents
                this.cachedSubscribedIds = new Set();
                const contentsItems: any[] = data.contents?.contents || [];
                contentsItems.forEach((content: any) => {
                    if (content.data?.id) { this.cachedSubscribedIds.add(content.data.id); }
                });

                const catalogueItems: any[] = data.catalogue?.catalogue || [];
                const subscriptionFilter = this.filters?.subscriptionFilter;
                const searchQuery = (query || this.query || '').trim();

                // Normaliza: minúsculas + quita acentos (innovación === innovacion)
                const normalize = (s: string): string =>
                    (s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
                const normalizedQuery = normalize(searchQuery);

                // Filtra por título ignorando acentos. Sin query → pasa todo.
                const matchesTitle = (i: any): boolean => {
                    if (!normalizedQuery) { return true; }
                    const title = normalize(i.data?.title || i.title || '');
                    return title.includes(normalizedQuery);
                };

                let finalList: any[];

                if (subscriptionFilter === 'subscribed') {
                    // "Inscrito": usar directamente getContents — son los cursos del usuario.
                    // NO filtrar catalogueItems porque el catálogo es paginado y puede no incluir
                    // todos los cursos inscritos. getContents sí los devuelve todos.
                    finalList = contentsItems.filter(matchesTitle);
                } else if (subscriptionFilter === 'not_subscribed') {
                    // "No inscrito": catálogo excluyendo inscritos, filtrando por título
                    finalList = catalogueItems.filter((i: any) => {
                        const id = i.data?.id || i.id;
                        return (!id || !this.cachedSubscribedIds.has(id)) && matchesTitle(i);
                    });
                } else {
                    // Sin filtro: catálogo + cursos inscritos, todos filtrados por título
                    const filteredCatalogue = catalogueItems.filter(matchesTitle);
                    const catalogueIds = new Set(filteredCatalogue.map((i: any) => i.data?.id || i.id));
                    const uniqueFromContents = contentsItems.filter((i: any) => {
                        const id = i.data?.id || i.id;
                        if (!id || catalogueIds.has(id)) { return false; }
                        return matchesTitle(i);
                    });
                    finalList = [...filteredCatalogue, ...uniqueFromContents];
                }

                this.contents = this.enrichCatalogueWithSubscriptionData(
                    finalList,
                    this.cachedSubscribedIds
                );
                this.originalContents = [...this.contents];
                this.pagination = subscriptionFilter === 'subscribed'
                    ? data.contents?.pagination     // paginar sobre mis cursos
                    : data.catalogue?.pagination;   // paginar sobre catálogo general
                this.isSearching = true;
                this.searching = false;
                this.loaderService.stop();
                setTimeout(() => this.animateCatalogueCards(), 50);
            },
            error: (err) => {
                console.error('[WATCH] forkJoin error:', err);
                this.searching = false;
                this.loaderService.stop();
            }
        });
    }




    loadMore(): void {
        if (this.loading) { return; }

        if (!(this.pagination?.currentPage < this.pagination?.lastPage)) { return; }

        this.loading = true;
        const scrubbedMe = { ...this.me };
        delete scrubbedMe.learningLanguages;

        const params = this.paramsService.getCatalogue(this.filters, this.company.id, this.query, this.pagination, { browse: this.params.type }, scrubbedMe);

        if (this.params.level) {
            this.contentProvider.getCatalogueSkillLevel(this.params.thematicId, this.params.level, params).subscribe((data) => {
                this.level.contents = this.level.contents.concat(data.contents);
                this.pagination = data.pagination;
                this.loading = false;
            }, () => { this.loading = false; });
        } else if (this.params.thematicId) {
            this.contentProvider.getCatalogueSkill(this.params.thematicId, params).subscribe((data) => {
                this.thematic.contents = this.thematic.contents.concat(data.contents);
                this.pagination = data.pagination;
                this.loading = false;
            }, () => { this.loading = false; });
        } else {
            this.fetchNextNonEmptyPage();
        }
    }

    private fetchNextNonEmptyPage(): void {
        if (!(this.pagination?.currentPage < this.pagination?.lastPage)) {
            this.loading = false;
            return;
        }

        const scrubbedMe = { ...this.me };
        delete scrubbedMe.learningLanguages;
        const params = this.paramsService.getCatalogue(
            this.filters, this.company.id, this.query, this.pagination,
            { browse: this.params.type }, scrubbedMe
        );

        const subscriptionFilter = this.filters?.subscriptionFilter;

        if (subscriptionFilter === 'subscribed') {
            // "Inscrito": cargar siguiente página de getContents (cursos del usuario)
            this.contentProvider.getContents(params).pipe(
                catchError(() => of({ contents: [], pagination: this.pagination }))
            ).subscribe({
                next: (data: any) => {
                    this.pagination = data.pagination || this.pagination;
                    const newItems: any[] = data.contents || [];
                    // Actualizar caché de ids suscritos
                    newItems.forEach((item: any) => {
                        if (item.data?.id) { this.cachedSubscribedIds.add(item.data.id); }
                    });
                    const enrichedItems = this.enrichCatalogueWithSubscriptionData(newItems, this.cachedSubscribedIds);
                    if (enrichedItems.length > 0) {
                        this.contents = this.contents.concat(enrichedItems);
                        this.originalContents = [...this.contents];
                    }
                    this.loading = false;
                },
                error: () => { this.loading = false; }
            });
        } else {
            this.contentProvider.getCatalogue(params).pipe(
                catchError(() => of({ catalogue: [], pagination: this.pagination }))
            ).subscribe({
                next: (data: any) => {
                    this.pagination = data.pagination || this.pagination;
                    let newItems: any[] = data.catalogue || [];

                    if (subscriptionFilter === 'not_subscribed') {
                        // Filtrar los ya inscritos
                        newItems = newItems.filter((i: any) => {
                            const id = i.data?.id || i.id;
                            return id && !this.cachedSubscribedIds.has(id);
                        });
                    }

                    const enrichedItems = this.enrichCatalogueWithSubscriptionData(newItems, this.cachedSubscribedIds);
                    if (enrichedItems.length > 0) {
                        this.contents = this.contents.concat(enrichedItems);
                        this.catalogue = this.catalogue.concat(enrichedItems);
                        this.originalCatalogue = [...this.catalogue];
                        this.originalContents = [...this.contents];
                        this.loading = false;
                    } else {
                        // Página vacía del backend: avanzar a la siguiente sin liberar loading
                        this.fetchNextNonEmptyPage();
                    }
                },
                error: () => { this.loading = false; }
            });
        }
    }

    get displayedCatalogue(): any[] {
        const start = (this.clientPage - 1) * this.ITEMS_PER_PAGE;
        return this.catalogue.slice(start, start + this.ITEMS_PER_PAGE);
    }

    get displayedContents(): any[] {
        const start = (this.clientPage - 1) * this.ITEMS_PER_PAGE;
        return this.contents.slice(start, start + this.ITEMS_PER_PAGE);
    }

    get totalPages(): number {
        const apiTotal = this.pagination?.total;
        const storeLen = this.isSearching ? this.contents.length : this.catalogue.length;
        const total = (apiTotal && apiTotal > storeLen) ? apiTotal : storeLen;
        return Math.max(1, Math.ceil(total / this.ITEMS_PER_PAGE));
    }

    get visiblePages(): number[] {
        const total = this.totalPages;
        if (total <= 7) { return Array.from({ length: total }, (_, i) => i + 1); }
        
        let pages: number[] = [];
        const windowSize = 3;
        
        let start = Math.max(1, this.clientPage - windowSize);
        let end = Math.min(total, start + (windowSize * 2));
        start = Math.max(1, end - (windowSize * 2));
        
        // Siempre mostrar primera página
        if (start > 1) {
            pages.push(1);
            if (start > 2) pages.push(-1); // -1 representa "..."
        }
        
        // Páginas alrededor de la actual
        for (let i = start; i <= end; i++) {
            if (!pages.includes(i) && i !== -1) pages.push(i);
        }
        
        // Siempre mostrar última página
        if (end < total) {
            if (end < total - 1) pages.push(-1); // -1 representa "..."
            pages.push(total);
        }
        
        return pages;
    }

    public goToPage(page: number): void {
        if (page < 1 || page > this.totalPages || this.loading) { return; }
        const neededCount = page * this.ITEMS_PER_PAGE;
        const store = this.isSearching ? this.contents : this.catalogue;
        if (neededCount > store.length && this.pagination?.currentPage < this.pagination?.lastPage) {
            this.loading = true;
            this.loadUntilEnough(neededCount, () => {
                this.loading = false;
                this.clientPage = page;
                window.scrollTo({ top: 0, behavior: 'smooth' });
            });
        } else {
            this.clientPage = page;
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }

    public goToFirstPage(): void {
        this.goToPage(1);
    }

    public goToLastPage(): void {
        this.goToPage(this.totalPages);
    }

    public goToNextRange(): void {
        const nextPage = Math.min(this.clientPage + 10, this.totalPages);
        this.goToPage(nextPage);
    }

    public goToPreviousRange(): void {
        const prevPage = Math.max(this.clientPage - 10, 1);
        this.goToPage(prevPage);
    }

    private loadUntilEnough(neededCount: number, onComplete: () => void): void {
        const store = this.isSearching ? this.contents : this.catalogue;
        if (store.length >= neededCount || !(this.pagination?.currentPage < this.pagination?.lastPage)) {
            onComplete();
            return;
        }
        const scrubbedMe = { ...this.me };
        delete scrubbedMe.learningLanguages;
        const params = this.paramsService.getCatalogue(this.filters, this.company.id, this.query, this.pagination, { browse: this.params.type }, scrubbedMe);
        this.contentProvider.getCatalogue(params).pipe(catchError(() => of({ catalogue: [], pagination: null }))).subscribe({
            next: (data: any) => {
                const enrichedItems = this.enrichCatalogueWithSubscriptionData(data.catalogue || [], this.cachedSubscribedIds);
                this.catalogue = this.catalogue.concat(enrichedItems);
                this.contents = this.contents.concat(enrichedItems);
                this.originalCatalogue = [...this.catalogue];
                this.originalContents = [...this.contents];
                this.pagination = data.pagination;
                this.loadUntilEnough(neededCount, onComplete);
            },
            error: () => { onComplete(); }
        });
    }

    private loadRemainingPages(onComplete: () => void): void {
        if (!(this.pagination?.currentPage < this.pagination?.lastPage)) {
            onComplete();
            return;
        }
        const currentPage = this.pagination.currentPage;
        const lastPage = this.pagination.lastPage;
        const perPage = this.pagination.perPage;
        const scrubbedMe = { ...this.me };
        delete scrubbedMe.learningLanguages;

        const pageRequests = [];
        for (let p = currentPage; p < lastPage; p++) {
            const mockPagination = { currentPage: p, perPage } as any;
            const params = this.paramsService.getCatalogue(
                this.filters, this.company.id, this.query, mockPagination, { browse: this.params.type }, scrubbedMe
            );
            pageRequests.push(
                this.contentProvider.getCatalogue(params).pipe(catchError(() => of({ catalogue: [] })))
            );
        }

        forkJoin(pageRequests).subscribe({
            next: (results: any[]) => {
                let allCatalogue = [...this.catalogue];
                let allContents = [...this.contents];
                results.forEach((data: any) => {
                    const enrichedItems = this.enrichCatalogueWithSubscriptionData(
                        data.catalogue || [],
                        this.cachedSubscribedIds
                    );
                    allCatalogue = allCatalogue.concat(enrichedItems);
                    allContents = allContents.concat(enrichedItems);
                });
                this.catalogue = allCatalogue;
                this.contents = allContents;
                this.originalCatalogue = [...allCatalogue];
                this.originalContents = [...allContents];
                onComplete();
            },
            error: () => { onComplete(); }
        });
    }

    navigate(type: string, enable: boolean): void {
        if (enable) {
            switch (type) {
                case 'catalogue':
                    this.router.navigate(['learn', this.company.slug, 'catalogue']);
                    break;
                case 'thematic':
                    this.router.navigate(['learn', this.company.slug, 'catalogue', this.params.type, 'thematic', this.params.thematicId]);
                    break;
                default:
                    this.router.navigate(['learn', this.company.slug, 'catalogue', type]);
            }
        }
    }

    getLevel(): string {
        switch (this.params.level) {
            case '0':
                return 'words.appropriate-for-all';
            case '1':
                return 'words.introductive';
            case '2':
                return 'words.intermediate';
            case '3':
                return 'words.confirmed';
            default:
                return '';
        }
    }


    //catalogue new
    public getCatalogue(): void {
        /*
        const params = {
            company_id: this.company.id,
            per_page: 50
        };

        this.contentProvider.getCatalogue(params).subscribe((data) => {
            this.catalogue = data.catalogue; // solo primera página
            this.pagination = data.pagination;
            this.isSearching = false;
        });*/
        this.catalogue = this.route.snapshot.data.watch.catalogue;
        this.originalCatalogue = [...this.catalogue];
        this.pagination = this.route.snapshot.data.watch.pagination;
        this.isSearching = false;
        this.clientPage = 1;
        setTimeout(() => this.animateCatalogueCards(), 50);
    }

    private animateCatalogueCards(): void {
        const selector = this.viewMode === 'grid'
            ? '.grid-catalogue .relative'
            : '.card-course-grid content-card-list';
        const cards = Array.from(document.querySelectorAll(selector));
        if (!cards.length) return;
        gsap.fromTo(cards,
            { opacity: 0, y: 28, scale: 0.96 },
            { opacity: 1, y: 0, scale: 1, duration: 0.45, stagger: 0.055, ease: 'power2.out', clearProps: 'all', overwrite: 'auto' }
        );
    }

    // Métodos de filtros
    private getMeta(): void {
        this.contentProvider.getMeta('catalogue').subscribe((meta) => {
            this.availableSkills = meta.contentSkills;
            this.availableTypes = this.getTypesOptions(meta);
            this.availableLanguages = this.getLanguagesOptions(meta.languages);
            this.availableProviders = this.getProvidersOptions(meta.providers);
            
            // Organizar en dos grupos filtros
            // Grupo 1: Tipos de contenido (Curso, Ruta, Contenido Externo)
            this.groupedTypes = this.availableTypes.map(type => Object.assign({}, type));
            
            // Grupo 2: Proveedores (Netzun, Griky, etc.)
            this.groupedProviders = this.availableProviders.map(provider => Object.assign({}, provider));
            
            // LÓGICA MEJORADA: Inicializar contadores correctamente basándose en el estado real
            this.lastSelectedTypesCount = this.groupedTypes.filter(type => type.isSelected).length;
            this.lastSelectedProvidersCount = this.groupedProviders.filter(provider => provider.isSelected).length;
            
            console.log('[WATCH] getMeta - Contadores inicializados. Tipos:', this.lastSelectedTypesCount, 'Proveedores:', this.lastSelectedProvidersCount);
            
            this.setFilters();
            this.isLoadingFilters = false;
            
            /* ===== RESPALDO CARRUSEL: INICIALIZACIÓN DE CONTROLES =====
            setTimeout(() => this.updateScrollButtons(), 300);
            */
        });
    }

    private getTypesOptions(data: any) {
        return Object.keys(data.contentTypes)
            .map((type) => ({
                id: `type-${type}`,
                label: this.translateService.instant(`api.content-type.${type.split(/(?=[A-Z])/).join('_').toLowerCase()}`),
                value: type.split(/(?=[A-Z])/).join('_').toLowerCase(),
                isSelected: this.filters.contentTypes?.includes(type.split(/(?=[A-Z])/).join('_').toLowerCase()),
                children: this.getSubTypesOptions(data, type)
            }))
            .sort((a, b) => a.label.localeCompare(b.label));
    }

    private getSubTypesOptions(data: any, key: string) {
        const subtypes = data[`${key}Types`];
        if (!subtypes) {
            return [];
        }

        return Object.keys(subtypes)
            .map((subtype) => ({
                id: `type-${key}-subtype-${subtype}`,
                label: this.translateService.instant(`words.course-type.${subtype}`),
                value: subtype,
                isSelected: this.filters[`${key}Types`]?.includes(subtype)
            }))
            .sort((a, b) => a.label.localeCompare(b.label));
    }

    private getProvidersOptions(providers) {
        const providerIds = this.filters?.providers ? this.filters.providers : [];
        const label = this.company.experience
            ? this.company.experience.displayName
                ? this.company.experience.displayName
                : this.company.experience.name
            : this.company.name;

        return providers.map(provider => ({
            label: provider.id === 'company' ? label : provider.name,
            value: provider.id,
            isSelected: providerIds.includes(provider.id)
        }));
    }

    private getLanguagesOptions(languages) {
        const languageIds = this.filters?.langs ? this.filters.langs : this.me.learningLanguages.map(lang => lang.id);

        return languages.map((lang, idx) => ({
            id: idx,
            label: lang.id === 'undefined' ? this.translateService.instant('words.multilingual') : lang.name,
            value: lang.id,
            isSelected: languageIds.includes(lang.id)
        }));
    }

    private setFilters(): void {
        this.filtersModal = [
            {
                name: 'langs',
                type: 'multiselect',
                label: this.translateService.instant('words.languages'),
                displayValue: this.availableLanguages.filter(lang => lang.isSelected).map(lang => lang.label).join(', '),
                options: this.availableLanguages
            },
            {
                name: 'providers',
                type: 'checkbox',
                label: this.translateService.instant('words.providers'),
                options: this.availableProviders
            },
            {
                name: 'skill',
                type: 'skill',
                label: this.translateService.instant('words.skill'),
                selected: { skill: null, level: [] },
                query: null,
                displayLimit: 12,
                options: this.availableSkills
            }
        ];
    }

    public onSelectType(option) {
        option.isSelected = !option.isSelected;

        if (option.children) {
            this.getIterativeCheck(option);
        } else {
            const selectedType = this.groupedTypes.find(type => {
                return type.children.find(subtype => subtype.id.includes(option.id));
            });
            if (selectedType) {
                selectedType.isSelected = selectedType.children.some(subtype => subtype.isSelected);
            }
        }
        
        // Mantener sincronizado availableTypes
        this.availableTypes = this.groupedTypes.map(t => Object.assign({}, t));

        // Detectar si hay tipos seleccionados ANTES de hacer cualquier otra operación
        const currentSelectedTypesCount = this.groupedTypes.filter(type => type.isSelected).length;
        const hadTypesSelected = this.lastSelectedTypesCount > 0;
        const hasTypesSelected = currentSelectedTypesCount > 0;
        
        console.log('[WATCH] onSelectType - Tipo seleccionado:', option.label, 'isSelected:', option.isSelected);
        console.log('[WATCH] onSelectType - Tipos antes:', this.lastSelectedTypesCount, 'Tipos ahora:', currentSelectedTypesCount);
        console.log('[WATCH] onSelectType - Todos los tipos:', this.groupedTypes.map(t => ({ label: t.label, isSelected: t.isSelected })));
        
        // LÓGICA MEJORADA: Si se AGREGÓ el PRIMER tipo (Grupo 1 estaba vacío), SIEMPRE limpia Grupo 2 (proveedores)
        if (!hadTypesSelected && hasTypesSelected) {
            console.log('[WATCH] onSelectType - Limpiando proveedores porque se seleccionó el PRIMER tipo del Grupo 1');
            this.clearProvidersFilter();
            this.lastSelectedProvidersCount = 0;
        }
        
        // LÓGICA: Si se DESELECCIONÓ el último tipo, permite más cambios pero no hace nada especial
        if (hadTypesSelected && !hasTypesSelected) {
            console.log('[WATCH] onSelectType - Se deseleccionaron todos los tipos del Grupo 1');
        }
        
        // Actualizar contador ANTES de guardar filtros
        this.lastSelectedTypesCount = currentSelectedTypesCount;
        console.log('[WATCH] onSelectType - Guardado: lastSelectedTypesCount =', this.lastSelectedTypesCount);
        
        this.saveFilters();
    }

    public onInlineMultiselectChange(option, filterName: string, optionsArray: any[]) {
        const opt = optionsArray.find(o => o.value === option.value);
        opt.isSelected = !opt.isSelected;

        const selectedValues = optionsArray
            .filter(o => o.isSelected)
            .map(o => o.value);

        // Actualizar el filtro
        this.filters[filterName] = selectedValues;
        
        // Mantener sincronizado availableProviders si es necesario
        if (filterName === 'providers') {
            this.availableProviders = this.groupedProviders.map(p => Object.assign({}, p));
        }

        console.log('[WATCH] onInlineMultiselectChange - Filtro:', filterName);
        console.log('[WATCH] onInlineMultiselectChange - Opción:', option.label, 'isSelected:', opt.isSelected);
        console.log('[WATCH] onInlineMultiselectChange - Valores seleccionados:', selectedValues);
        console.log('[WATCH] onInlineMultiselectChange - Tipos disponibles:', this.groupedTypes.map(t => ({ label: t.label, isSelected: t.isSelected })));

        // LÓGICA MEJORADA: Detectar cambios en Grupo 2 (proveedores)
        if (filterName === 'providers') {
            const hadProvidersSelected = this.lastSelectedProvidersCount > 0;
            const hasProvidersSelected = selectedValues.length > 0;
            
            console.log('[WATCH] onInlineMultiselectChange - Proveedores antes:', this.lastSelectedProvidersCount, 'Proveedores ahora:', selectedValues.length);
            
            // LÓGICA MEJORADA: Si se AGREGÓ el PRIMER proveedor (Grupo 2 estaba vacío), SIEMPRE limpia Grupo 1 (tipos)
            if (!hadProvidersSelected && hasProvidersSelected) {
                console.log('[WATCH] onInlineMultiselectChange - Limpiando tipos de contenido porque se seleccionó el PRIMER proveedor del Grupo 2');
                this.clearContentTypesFilter();
                this.lastSelectedTypesCount = 0;
            }
            
            // LÓGICA: Si se DESELECCIONÓ el último proveedor, permite más cambios pero no hace nada especial
            if (hadProvidersSelected && !hasProvidersSelected) {
                console.log('[WATCH] onInlineMultiselectChange - Se deseleccionaron todos los proveedores del Grupo 2');
            }
            
            // Actualizar contador ANTES de guardar filtros
            this.lastSelectedProvidersCount = selectedValues.length;
            console.log('[WATCH] onInlineMultiselectChange - Guardado: lastSelectedProvidersCount =', this.lastSelectedProvidersCount);
        }

        console.log('[WATCH] onInlineMultiselectChange - Tipos después de limpiar:', this.groupedTypes.map(t => ({ label: t.label, isSelected: t.isSelected })));
        this.saveFilters();
    }

    public onClearTypeChip(option: any, event: Event): void {
        event.stopPropagation();
        event.preventDefault();

        if (!option?.isSelected) {
            return;
        }

        option.isSelected = false;

        // Sincronizar referencias para change detection
        this.groupedTypes = this.groupedTypes.map(type => {
            if (type.value === option.value) {
                const resetChildren = (type.children || []).map(child => ({
                    ...child,
                    isSelected: false
                }));

                return {
                    ...type,
                    isSelected: false,
                    children: resetChildren
                };
            }

            return { ...type };
        });
        this.availableTypes = this.groupedTypes.map(t => Object.assign({}, t));

        this.lastSelectedTypesCount = this.groupedTypes.filter(type => type.isSelected).length;

        this.saveFilters();
    }

    public onClearProviderChip(option: any, event: Event): void {
        event.stopPropagation();
        event.preventDefault();

        if (!option?.isSelected) {
            return;
        }

        this.groupedProviders = this.groupedProviders.map(provider => {
            if (provider.value === option.value) {
                return {
                    ...provider,
                    isSelected: false,
                    isChecked: false
                };
            }
            return provider;
        });

        this.availableProviders = this.groupedProviders.map(p => Object.assign({}, p));

        const remainingProviders = this.groupedProviders.filter(provider => provider.isSelected).map(provider => provider.value);

        this.filters = DataHelper.merge(this.filters, { providers: remainingProviders });
        this.lastSelectedProvidersCount = remainingProviders.length;

        if (this.filtersModal) {
            this.filtersModal = this.filtersModal.map(filter => {
                if (filter.type === 'checkbox' && filter.options.length) {
                    filter.options = filter.options.map(optionItem => ({
                        ...optionItem,
                        isSelected: remainingProviders.includes(optionItem.value),
                        isChecked: remainingProviders.includes(optionItem.value)
                    }));
                }
                return filter;
            });
        }

        this.saveFilters();
    }

    private getIterativeCheck(parent: any) {
        parent.children = parent.children.map((child: any) => {
            child.isSelected = parent.isSelected;
            return child;
        });
        return parent;
    }

    private getSubTypesFilters(key: string) {
        const subTypes = this.groupedTypes.find(t => t.value === key && t.isSelected);

        return subTypes ? subTypes.children.filter(t => t.isSelected).map(t => t.value) : [];
    }

    private saveFilters(): void {
        // Construir objeto de filtros de una sola vez
        const contentTypeValues = this.groupedTypes.filter(t => t.isSelected).map(t => t.value);
        const courseTypeValues = this.getSubTypesFilters('course');
        const externalContentTypeValues = this.getSubTypesFilters('external_content');
        const externalResourceTypeValues = this.getSubTypesFilters('external_resource');

        // Actualizar filtros: SOLO asignar si hay valores, NO asignar arrays vacíos
        if (contentTypeValues.length > 0) {
            this.filters.contentTypes = contentTypeValues;
        } else {
            delete this.filters.contentTypes;
        }
        
        if (courseTypeValues.length > 0) {
            this.filters.courseTypes = courseTypeValues;
        } else {
            delete this.filters.courseTypes;
        }
        
        if (externalContentTypeValues.length > 0) {
            this.filters.externalContentTypes = externalContentTypeValues;
        } else {
            delete this.filters.externalContentTypes;
        }
        
        if (externalResourceTypeValues.length > 0) {
            this.filters.externalResourceTypes = externalResourceTypeValues;
        } else {
            delete this.filters.externalResourceTypes;
        }

        // Actualizar bandera de filtros activos basándose en AMBOS grupos (+ filtro de inscripción)
        const hasContentTypeFilters = contentTypeValues.length > 0;
        const hasProviderFilters = (this.filters.providers && this.filters.providers.length > 0);
        const hasSubscriptionFilter = !!(this.filters.subscriptionFilter);
        this.activeFilters = hasContentTypeFilters || hasProviderFilters || hasSubscriptionFilter;
        
        console.log('[WATCH] saveFilters - activeFilters:', this.activeFilters, 'Tipos:', contentTypeValues.length, 'Proveedores:', this.filters.providers?.length || 0);
        
        // Preservar búsqueda actual al guardar filtros
        this.search(this.query || undefined);
    }

    /* ===== RESPALDO CARRUSEL: CONTROLES DE DESPLAZAMIENTO =====
    public scrollCategoriesLeft(): void {
        const container = document.getElementById('category-container');
        if (container) {
            container.scrollBy({ left: -200, behavior: 'smooth' });
            // Actualizar estado después de un delay
            setTimeout(() => this.updateScrollButtons(), 300);
        }
    }

    public scrollCategoriesRight(): void {
        const container = document.getElementById('category-container');
        if (container) {
            container.scrollBy({ left: 200, behavior: 'smooth' });
            // Actualizar estado después de un delay
            setTimeout(() => this.updateScrollButtons(), 300);
        }
    }

    public onCategoryContainerScroll(): void {
        this.updateScrollButtons();
    }

    private updateScrollButtons(): void {
        const container = document.getElementById('category-container');
        if (container) {
            // Verificar si hay contenido que desplazar hacia la izquierda
            this.canScrollLeft = container.scrollLeft > 0;
            
            // Verificar si hay contenido que desplazar hacia la derecha
            this.canScrollRight = container.scrollLeft + container.clientWidth < container.scrollWidth;
        }
    }
    ===== FIN RESPALDO ===== */

    /**
     * Resetea todos los filtros (tipos de contenido y proveedores)
     * Llamado desde el botón de reset de topbar-filters o cuando el evento es emitido
     */
    public onFilterReset(): void {
        // Resetear array de tipos
        this.groupedTypes = this.groupedTypes.map(type => {
            const newType = Object.assign({}, type);
            newType.isSelected = false;
            // Limpiar también los children (subtypes)
            if (newType.children && newType.children.length > 0) {
                newType.children = newType.children.map(subtype => {
                    const newSubtype = Object.assign({}, subtype);
                    newSubtype.isSelected = false;
                    return newSubtype;
                });
            }
            return newType;
        });
        this.groupedTypes = Object.assign([], this.groupedTypes);
        
        // Actualizar también availableTypes
        this.availableTypes = this.groupedTypes.map(t => Object.assign({}, t));

        // Resetear array de proveedores
        this.groupedProviders = this.groupedProviders.map(provider => {
            const newProvider = Object.assign({}, provider);
            newProvider.isSelected = false;
            newProvider.isChecked = false;
            return newProvider;
        });
        this.groupedProviders = Object.assign([], this.groupedProviders);
        
        // Actualizar también availableProviders
        this.availableProviders = this.groupedProviders.map(p => Object.assign({}, p));

        // Resetear filtros modal
        if (this.filtersModal) {
            this.filtersModal = this.filtersModal.map(filter => {
                if ((filter.name === 'providers' || filter.name === 'langs') && filter.options?.length) {
                    filter.options = filter.options.map(option => ({
                        ...option,
                        isSelected: false,
                        isChecked: false
                    }));
                }
                return filter;
            });
        }

        // Resetear estado de filtros
        this.filters = {};
        this.lastSelectedTypesCount = 0;
        this.lastSelectedProvidersCount = 0;
        this.activeFilters = false;
        this.query = null;

        // Forzar detección de cambios para que el binding two-way [(activeFilters)] se propague al padre
        this.changeDetectorRef.markForCheck();

        console.log('[WATCH] onFilterReset - Filtros reseteados completamente');
        
        // Llamar a search para recargar sin filtros y emitir cambios
        this.search();
    }

    // Sincronizar filtros desde topbar-filters hacia la sección de carrusel
    private syncFiltersFromTopbar(): void {
        if (!this.filters) return;

        // Sincronizar tipos de contenido
        if (this.filters.contentTypes && this.groupedTypes.length > 0) {
            this.groupedTypes = this.groupedTypes.map(type => {
                return {
                    ...type,
                    isSelected: this.filters.contentTypes.includes(type.value),
                    children: type.children ? type.children.map(child => ({
                        ...child,
                        isSelected: this.filters.contentTypes.includes(child.value)
                    })) : []
                };
            });
        }

        // Sincronizar proveedores
        if (this.filters.providers && this.groupedProviders.length > 0) {
            this.groupedProviders = this.groupedProviders.map(provider => {
                return {
                    ...provider,
                    isSelected: this.filters.providers.includes(provider.value),
                    children: provider.children ? provider.children.map(child => ({
                        ...child,
                        isSelected: this.filters.providers.includes(child.value)
                    })) : []
                };
            });
        }
    }

    // TrackBy para mejorar detección de cambios en *ngFor
    public trackByValue(index: number, item: any): any {
        return item.value || item.id || index;
    }

    // Handlers para msc-shared-search-sort-bar
    public viewMode: 'grid' | 'list' = 'grid';
    public activeRanking: string = '';
    public activeSaved: boolean = false;

    public onQueryChange(query: string): void {
        this.activeRanking = '';
        this.query = query;
        this.search(query);
    }

    public onSortChange(filters: any): void {
        this.activeRanking = '';
        this.filters = DataHelper.merge(this.filters, { order: filters.order });

        if (filters.order === 'title') {
            this.catalogue = [...this.catalogue].sort((a, b) =>
                (a.data?.title || '').localeCompare(b.data?.title || ''));
            this.contents = [...this.contents].sort((a, b) =>
                (a.data?.title || '').localeCompare(b.data?.title || ''));
        } else if (filters.order === '-title') {
            this.catalogue = [...this.catalogue].sort((a, b) =>
                (b.data?.title || '').localeCompare(a.data?.title || ''));
            this.contents = [...this.contents].sort((a, b) =>
                (b.data?.title || '').localeCompare(a.data?.title || ''));
        } else {
            this.search(this.query || undefined);
        }
    }

    public onRankingChange(ranking: string): void {
        // Ranking y guardados son excluyentes - desmarcar saved cuando se activa ranking
        if (ranking) {
            this.activeSaved = false;
        }
        this.activeRanking = ranking;

        // Ensure originalCatalogue is synced (in browse mode, originalContents may be empty)
        if (!this.originalCatalogue.length && this.catalogue.length) {
            this.originalCatalogue = [...this.catalogue];
        }
        if (!this.originalContents.length && this.contents.length) {
            this.originalContents = [...this.contents];
        }

        // Reset ranking: restore original data
        if (!ranking) {
            this.catalogue = this.originalCatalogue.length ? [...this.originalCatalogue] : [...this.catalogue];
            this.contents  = this.originalContents.length  ? [...this.originalContents]  : [...this.contents];
            this.clientPage = 1;
            return;
        }

        const applyRanking = () => {
            // In browse mode use catalogue/originalCatalogue; in search mode use contents/originalContents
            const srcCat = this.originalCatalogue.length ? this.originalCatalogue : this.catalogue;
            const srcCon = this.originalContents.length ? this.originalContents : (this.isSearching ? this.contents : srcCat);
            const getRating = (item: any): number => Number(item.data?.rating) || 0;
            const isRated = (item: any): boolean => getRating(item) > 0;
            const isUnrated = (item: any): boolean => getRating(item) <= 0;
            if (ranking === 'top') {
                // Solo calificados (rating > 0), descendente
                this.catalogue = [...srcCat].filter(isRated).sort((a, b) => getRating(b) - getRating(a));
                this.contents  = [...srcCon].filter(isRated).sort((a, b) => getRating(b) - getRating(a));
            } else if (ranking === 'lowest') {
                // Solo calificados (rating > 0), ascendente
                this.catalogue = [...srcCat].filter(isRated).sort((a, b) => getRating(a) - getRating(b));
                this.contents  = [...srcCon].filter(isRated).sort((a, b) => getRating(a) - getRating(b));
            } else if (ranking === 'unrated') {
                // Solo sin calificar (rating <= 0)
                this.catalogue = [...srcCat].filter(isUnrated);
                this.contents  = [...srcCon].filter(isUnrated);
            }
        };

        if (this.pagination?.currentPage < this.pagination?.lastPage) {
            this.loading = true;
            this.loadingFilter = true;
            this.loadRemainingPages(() => {
                this.loading = false;
                this.loadingFilter = false;
                if (this.pagination) {
                    this.pagination.currentPage = this.pagination.lastPage;
                }
                applyRanking();
                this.clientPage = 1;
            });
        } else {
            applyRanking();
            this.clientPage = 1;
        }
    }

    public onViewModeChange(mode: 'grid' | 'list'): void {
        this.viewMode = mode;
    }

    public onSubscriptionFilterChange(value: string | null): void {
        this.filters = DataHelper.merge(this.filters, { subscriptionFilter: value });
        // Recalcular activeFilters igual que saveFilters()
        const hasContentTypeFilters = (this.filters.contentTypes && this.filters.contentTypes.length > 0);
        const hasProviderFilters = (this.filters.providers && this.filters.providers.length > 0);
        const hasSubscriptionFilter = !!(this.filters.subscriptionFilter);
        this.activeFilters = hasContentTypeFilters || hasProviderFilters || hasSubscriptionFilter;
        this.search(this.query || undefined);
    }

    public onSavedChange(active: boolean): void {
        this.activeSaved = active;

        if (!active) {
            // Restore original data
            this.catalogue = this.originalCatalogue.length ? [...this.originalCatalogue] : [...this.catalogue];
            this.contents  = this.originalContents.length  ? [...this.originalContents]  : [...this.contents];
            this.clientPage = 1;
            return;
        }

        this.activeRanking = '';
        this.loadingFilter = true;
        const params = this.paramsService.getCatalogue({}, this.company.id, this.query, null, null, this.me);
        this.contentProvider.getSavedContents(params).subscribe({
            next: (data) => {
                const saved = (data.contents || []).map((c: any) => ({ ...c, saved: true }));
                this.catalogue = [...saved];
                this.contents  = [...saved];
                this.clientPage = 1;
                this.loadingFilter = false;
            },
            error: () => {
                this.loadingFilter = false;
            }
        });
    }
    private clearProvidersFilter(): void {
        console.log('[WATCH] clearProvidersFilter - INICIANDO');
        
        // Crear NUEVO array de proveedores para forzar change detection
        this.groupedProviders = this.groupedProviders.map(provider => {
            const newProvider = Object.assign({}, provider);
            newProvider.isSelected = false;
            newProvider.isChecked = false;
            return newProvider;
        });
        
        // Actualizar también availableProviders
        this.availableProviders = this.groupedProviders.map(p => Object.assign({}, p));
        
        // Forzar actualización usando Object.assign
        this.groupedProviders = Object.assign([], this.groupedProviders);
        
        // Limpiar el filtro en filters
        this.filters = DataHelper.merge(this.filters, { providers: [] });
        
        console.log('[WATCH] clearProvidersFilter - COMPLETADO. Proveedores:', this.groupedProviders.map(p => ({ label: p.label, isSelected: p.isSelected })));
    }

    private clearContentTypesFilter(): void {
        // Crear nuevo array para forzar Angular change detection
        console.log('[WATCH] clearContentTypesFilter - Limpiando tipos de contenido del Grupo 1');
        
        // Limpiar tipos padre
        this.groupedTypes = this.groupedTypes.map(type => {
            const newType = Object.assign({}, type);
            newType.isSelected = false;
            // Limpiar también los children
            if (newType.children && newType.children.length > 0) {
                newType.children = newType.children.map(subtype => {
                    const newSubtype = Object.assign({}, subtype);
                    newSubtype.isSelected = false;
                    return newSubtype;
                });
            }
            return newType;
        });
        
        // Actualizar también availableTypes
        this.availableTypes = this.groupedTypes.map(t => Object.assign({}, t));
        
        // Forzar actualización usando Object.assign
        this.groupedTypes = Object.assign([], this.groupedTypes);
        
        // Limpiar los filtros en filters
        this.filters = DataHelper.merge(this.filters, { 
            contentTypes: [], 
            courseTypes: [], 
            externalContentTypes: [], 
            externalResourceTypes: [] 
        });
        
        console.log('[WATCH] clearContentTypesFilter - Tipos de contenido limpiados del Grupo 1. groupedTypes:', this.groupedTypes.map(t => ({ label: t.label, isSelected: t.isSelected })));
    }
}